<style scoped>
  .layout-footer {
    background-color: #0e90d2;
    left: 0px;
    bottom: 0;
    position: fixed;
    height: 49px;
    /*! line-height: 49px; */
    width: 100%
  }

  .layout-footer-row {
    left: 0px;
    bottom: 0;
    position: absolute;
    width: 100%;
  }

  .layout-footer-text {
    color: White
  }
</style>

<template>
  <div id="footer-md">
    <Modal v-model="modalQCode" title="宝能公务航空微信公众号">
      <p style="text-align:center"><img src='http://www.baonengjet.com/wp-content/themes/generalbusiness_free/images/two-dimensional.jpg' style='width:120px' /> </p>
    </Modal>
  <Footer class="layout-footer">
    <Row class="layout-footer-row">
      <Col span="6"><a href="tel:+8618666228267">
        <Icon type="ios-call" color="White" size="24" />
        <p><span class="layout-footer-text">客服电话</span></p>
      </a></Col>
      <Col span="6"><a href="#" @click='modalQCode=true'>
        <Icon type="md-share" color="White" size="24" />
        <p><span class="layout-footer-text">微信公众号</span></p>
      </a></Col>
      <Col span="6"><a href="http://www.baonengjet.com/%E8%81%94%E7%B3%BB%E5%AE%9D%E8%83%BD%E5%85%AC%E5%8A%A1/">
        <Icon type="ios-contact" color="White" size="24" />
        <p><span class="layout-footer-text">联系我们</span></p>
      </a></Col>
      <Col span="6"><a href="http://www.baonengjet.com/topics/%e5%ae%9d%e8%83%bd%e5%85%ac%e5%8a%a1%e8%88%aa%e7%a9%ba/">
        <Icon type="ios-jet" color="White" size="24" />
        <p><span class="layout-footer-text">关于我们</span></p>
      </a></Col>
    </Row>
  </Footer>
  </div>
</template>

<script>
export default {
  name: 'BnjFooterMobile',
  data () {
    return {
      msg: '',
      modalQCode: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bnj-footer-mobile.vue